module.exports = __webpack_public_path__ + "img/[闭嘴].31b0f34a.svg";